"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _setThemesInStore = _interopRequireDefault(require("./setThemesInStore"));

/**
 * Initializes the theme registry
 * @param {object} themes  The list of themes to add
 * @returns {*}
 */
var initializeThemeRegistry = function initializeThemeRegistry(themes) {
  return (0, _setThemesInStore.default)(themes);
};

var _default = initializeThemeRegistry;
exports.default = _default;